export default __webpack_public_path__ + "static/media/mcafee.8dd32e9b.svg";